import { render } from "./produkUnggulan.vue?vue&type=template&id=1e20ebd4"
import script from "./produkUnggulan.vue?vue&type=script&lang=js"
export * from "./produkUnggulan.vue?vue&type=script&lang=js"

import "./produkUnggulan.vue?vue&type=style&index=0&id=1e20ebd4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__